import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "Co je to tumbler a tromlovačka?",
    answer: "Tumbler (také tromlovačka nebo tromlovací zařízení) je rotační přístroj, který se používá pro tromlování a leštění kamenů a minerálů. Přístroj otáčí kameny v bubnu spolu s brusivem a vodou, čímž postupně brousí a leští jejich povrch. Je ideální pro hobby tromlování vlastních nálezů minerálů."
  },
  {
    question: "Kde si můžu půjčit tumbler v Brně?",
    answer: "Tumbler si můžete půjčit u nás v Brně! Nabízíme pronájem rotační tromlovačky Lortone (0.8 litru) za 250 Kč/týden. Osobní předání v Brně, poradíme s celým procesem tromlování a potřebným materiálem."
  },
  {
    question: "Kolik stojí půjčení tromlovačky?",
    answer: "Půjčení rotačního tumbleru stojí 250 Kč za týden. Cena zahrnuje osobní předání v Brně, poradenství s použitím a doporučení na vhodný materiál pro tromlování. Zařízení neposíláme, je nutné osobní vyzvednutí."
  },
  {
    question: "Jak dlouho trvá tromlování kamenů?",
    answer: "Kompletní tromlování a leštění kamenů obvykle trvá 2-4 týdny. Záleží na typu minerálů, jejich tvrdosti a požadované kvalitě leštění. Proces probíhá v několika fázích s různými typy brusiv, od hrubého broušení až po finální leštění."
  },
  {
    question: "Můžete vytromlovat kameny za mě?",
    answer: "Ano! Nabízíme službu kompletního tromlování a leštění vašich kamenů za vás. Cena je 900-1500 Kč za 0.5 kg minerálů, záleží na množství a typu kamenů. Kontaktujte nás pro přesnou cenu a domluvu."
  },
  {
    question: "Jaký máte typ tumbleru?",
    answer: "Máme Lortone rotační tromlovačku s objemem 0.8 litru. Je to kvalitní zařízení ze Spojených států, ideální pro hobby tromlování kamenů a leštění minerálů. Máme s ním výborné zkušenosti a rádi vám ukážeme, jak funguje."
  },
  {
    question: "Co potřebuji k tromlování minerálů?",
    answer: "K tromlování potřebujete tromlovačku (tumbler), kameny nebo minerály, brusivo v několika zrnitostech (hrubé, střední, jemné), leštící pastu a vodu. Rádi vám poradíme s výběrem správného brusiva a celým procesem při předání přístroje."
  },
  {
    question: "Mohu tromlovat jakékoli kameny?",
    answer: "Většinu kamenů a minerálů lze tromlovat, ale nejlepší výsledky jsou s tvrdšími kameny jako je křemen, achát, jaspis nebo ametyst. Měkčí minerály mohou vyžadovat opatrnější přístup. Rádi vám poradíme s vaší konkrétní kolekcí při předání."
  },
  {
    question: "Posíláte tromlovačku poštou?",
    answer: "Ne, tromlovačku neposíláme. Je nutné osobní vyzvednutí a vrácení v Brně. Při předání vám ukážeme, jak zařízení funguje a poradíme s celým procesem tromlování."
  },
  {
    question: "Jak probíhá půjčení tumbleru?",
    answer: "Půjčení je jednoduché: 1) Kontaktujte nás přes rezervační formulář, 2) Domluvíme si osobní předání v Brně, 3) Ukážeme vám, jak tumbler funguje a poradíme s materiálem, 4) Půjčíte si zařízení na dohodnutou dobu, 5) Po skončení tromlování vrátíte tromlovačku opět osobně."
  }
];

function FAQItem({ faq, isOpen, onToggle }) {
  return (
    <div className="border-b border-stone-200 last:border-b-0" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
      <button
        className="w-full py-3 sm:py-4 px-1 sm:px-2 flex justify-between items-start text-left hover:bg-stone-50 transition-colors min-h-[48px]"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="font-semibold text-sm sm:text-base text-stone-800 pr-4 sm:pr-8" itemProp="name">
          {faq.question}
        </span>
        {isOpen ? (
          <ChevronUp className="w-4 h-4 sm:w-5 sm:h-5 text-stone-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
        ) : (
          <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-stone-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
        )}
      </button>
      {isOpen && (
        <div className="pb-3 sm:pb-4 px-1 sm:px-2 text-sm sm:text-base text-stone-600" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
          <p itemProp="text">{faq.answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white rounded-lg shadow-md p-4 sm:p-6 md:p-8 mb-8" aria-label="Často kladené otázky o půjčení tumbleru" itemScope itemType="https://schema.org/FAQPage">
      <h2 className="text-2xl sm:text-3xl font-bold text-stone-800 mb-4 sm:mb-6">
        Často kladené otázky o půjčení tumbleru a tromlování minerálů
      </h2>
      <div className="space-y-0">
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            faq={faq}
            isOpen={openIndex === index}
            onToggle={() => toggleFAQ(index)}
          />
        ))}
      </div>
      <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-amber-50 rounded-lg border border-amber-200">
        <p className="text-stone-700 text-xs sm:text-sm">
          <strong>Máte další otázky o půjčení tromlovačky nebo tromlování kamenů?</strong> Neváhejte nás kontaktovat
          přes rezervační formulář výše. Rádi odpovíme na všechny vaše dotazy ohledně hobby tromlování, leštění minerálů a našich služeb.
        </p>
      </div>
    </section>
  );
}
